import { observer } from 'mobx-react'
import { useParams } from 'react-router'
import { ExerciseInWorkout } from '@entities/exercise'
import { workoutExecutionStore } from '@features/workout/execution/workoutExecutionStore'
import { useQueryParam } from '@shared/hooks/useQueryParams'
import { WorkoutType } from '@shared/hooks/trainingsNavigation/base'
import { WorkoutExecutionFlow } from '@pages/exercise/ui/WorkoutExecutionFlow'

export const CardioExecutionPage = observer(() => {
	const workoutType: WorkoutType | undefined = useQueryParam('workout_type') as
		| WorkoutType
		| undefined
	const { exerciseOrder, trainingID } = useParams<{ exerciseOrder: string; trainingID: string }>()
	const exercise: ExerciseInWorkout | null =
		workoutExecutionStore.getExerciseByOrder(+exerciseOrder)

	if (!exercise || !workoutType) {
		return null
	}

	return (
		<WorkoutExecutionFlow
			workoutType={workoutType}
			exercise={exercise}
			exerciseOrder={+exerciseOrder || -1}
			trainingID={+trainingID || -1}
			initialMode='cardio'
		/>
	)
})
